import { faArrowRight, faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const AddServices = () => {


    const [serviceImg, setServiceImg] = useState('');

    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const imgStoreKey = '1102b1b472176018cfdab59d9d885956';


    const onSubmitImage = data => {
        const imges = data.servicePhoto[0];
        const formData = new FormData();
        formData.append('image', imges);

        const url = `https://api.imgbb.com/1/upload?key=${imgStoreKey}`;
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data?.success === true) {
                    setServiceImg(data?.data?.url);
                    toast.success('Service Photo Added!!')
                }
            })
    }


    const onSubmitForm = data => {
        const newService = {
            img: serviceImg,
            title: data?.title,
            des: data?.des,
        }

        console.log(newService, 'new service')

        const url = `https://stark-wildwood-35883.herokuapp.com/myservices`
        fetch(url, {
            method: "POST",
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(newService)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data?.insertedId) {
                    toast.success('New Service Added Successfully!!!');
                    reset();
                }
            })
    }



    return (
        <div className='bg-slate-200 px-8 py-10 md:h-screen md:p-6 h-screen'>
            <div className='grid md:grid-cols-2 grid-cols-1  gap-6'>
                <div>
                    <form onSubmit={handleSubmit(onSubmitImage)}>
                        <div className="form-control w-full mb-2 border-2 p-4 bg-white  rounded-lg custom_shadow border-green-500 ">
                            <label className="label font-semibold  lg:text-lg md:text-medium">Service Photo <span className='text-xs text-yellow-500'>Photo should Circle</span> </label>
                            <input
                                type="file"
                                placeholder="Service Photo"
                                className="input input-bordered w-full cursor-pointer   "
                                {...register("servicePhoto", {
                                    required: {
                                        value: true,
                                        message: "Service Photo is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.servicePhoto?.type === 'required' && <span className="label-text-alt text-red-500 ">{errors.servicePhoto?.message}</span>}
                            </label>
                            <button type='submit' className='btn bg-green-500 border-0 text-white'> Add Photo <FontAwesomeIcon className='ml-2' icon={faImage} /> </button>
                        </div>
                    </form>
                </div>
                <div>
                    <form onSubmit={handleSubmit(onSubmitForm)}>
                        <div className="form-control w-full mb-2 border-2 p-4 bg-white  rounded-lg custom_shadow border-green-500 ">
                            <h2 className='text-2xl font-bold text-green-500 text-center py-3'>Add New Service</h2>

                            <label className="label font-semibold lg:text-lg md:text-medium ">Service title</label>
                            <textarea
                                type="text"
                                placeholder="Service Title"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered  "
                                {...register("title", {
                                    required: {
                                        value: true,
                                        message: " Service title is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.title?.type === 'required' && <span className="label-text-alt text-red-500 ">{errors.title?.message}</span>}
                            </label>

                            <label className="label font-semibold lg:text-lg md:text-medium"> Service description </label>
                            <textarea
                                type="text"
                                placeholder="Service Description"
                                style={{ resize: 'none' }}
                                className="textarea textarea-bordered  "
                                {...register("des", {
                                    required: {
                                        value: true,
                                        message: "Service description is required"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.des?.type === 'required' && <span className="label-text-alt text-red-500">{errors.des.message}</span>}
                            </label>
                            <button type='submit' className='btn bg-green-500 mt-2 border-0 text-white'> Add New Service<FontAwesomeIcon className='ml-2' icon={faArrowRight} /> </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddServices;